import React from 'react';
import { format } from 'date-fns';
export var Card = function Card(_ref) {
  var title = _ref.title,
      excerpt = _ref.excerpt,
      image = _ref.image,
      path = _ref.path,
      date = _ref.date,
      _ref$excerptClassName = _ref.excerptClassName,
      excerptClassName = _ref$excerptClassName === void 0 ? '' : _ref$excerptClassName;
  return /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-image"
  }, /*#__PURE__*/React.createElement("figure", {
    className: "image is-2by1"
  }, /*#__PURE__*/React.createElement("img", {
    src: image.url,
    alt: image.alt
  }))), /*#__PURE__*/React.createElement("div", {
    className: "card-content"
  }, /*#__PURE__*/React.createElement("p", {
    className: "card-header-subtitle is-size-7    has-text-grey"
  }, format(date, 'dd.MM.yyyy')), /*#__PURE__*/React.createElement("p", {
    className: "card-header-title"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "content " + excerptClassName
  }, /*#__PURE__*/React.createElement("div", {
    className: "excerpt"
  }, excerpt))), /*#__PURE__*/React.createElement("div", {
    className: "card-footer"
  }, /*#__PURE__*/React.createElement("a", {
    className: "has-text-weight-semibold",
    href: "/" + path
  }, "Las\u012Bt vair\u0101k")));
};
export default Card;